// eslint-disable-next-line no-unused-vars
import crmService from '../../services/crmService'
export default {
  state: {
    users: [],
    statuses: [],
    projects: [],
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users
    },
    SET_USER_STATUSES(state, statuses) {
      state.statuses = statuses
    },
    SET_PROJECTS(state, projects) {
      state.projects = projects
    },
  },
  actions: {
    fetchUsers({ commit }, token) {
      return crmService.fetchUsers(token).then(res => {
        commit('SET_USERS', res.data)
      })
    },
    fetchUserStatuses({ commit }, token) {
      return crmService.fetchUserStatuses(token).then(res => {
        commit('SET_USER_STATUSES', res.data)
      })
    },
    changeUserStatus(context, payload) {
      return crmService.changeUserStatus(
        payload.userId,
        payload.statusId,
        payload.token
      )
    },
    async fetchProjects({ commit }, token) {
      crmService
        .fetchProjects(token)
        .then(res => commit('SET_PROJECTS', res.data))
    },
  },
  getters: {
    usersAll: state => state.users,
    userStatuses: state => state.statuses,
    projects: state => state.projects,
  },
}
